import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import {
  Label,
  useField,
} from '../../../../../../1stlog-ui/src/components/Field'
import { ListGroupItem } from '../../../../../../1stlog-ui/src/components/ListGroup'
import useOrderEntry from '../../../useOrderEntry'

const Wrapper = styled(ListGroupItem)``

const PrintLabel = (props) => {
  const {} = props

  const { currentPrinter } = useOrderEntry()

  return (
    <Wrapper>
      <Label>{i18n.t('label_print', 'Labeldruck')}</Label>
      <div>
        {i18n.t(
          'the_shipping_label_will_be_send_to_the_following_printer', 
          'Das Versandlabel wird an den folgenden Drucker übermittelt')}:{' '}
        <strong>{lodash.get(currentPrinter, 'name')}</strong>
      </div>
    </Wrapper>
  )
}

export default PrintLabel
